import * as S from '@/components/Footer/style';
import FooterLogo from '@/assets/img/logo/greenLogo.png';
import LineIcon from '../Icon/lineIcon';
import useIsMobile from '@/hooks/useIsMobile';
import kaggLogo from '@/assets/img/logo/kagg.png';
const Footer = () => {
	const isMobile = useIsMobile(1225);
	return (
		<S.FooterContainer>
			<S.FooterWrapper>
				<S.FooterContent>
					<S.FooterAbout>
						<S.ContentBox>
							<S.FooterContact>
								<S.FooterTitle>타이키파트너스 주식회사</S.FooterTitle>
							</S.FooterContact>
							<S.FooterContact>
								<S.FooterInfo>대표이사 : 이경익</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>주소 : 서울 송파구 올림픽로 82, 8층(잠실동, 현대빌딩)</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>사업자등록번호 : 851-88-02840</S.FooterInfo>
							</S.FooterContact>
							<S.FooterContact>
								<S.FooterInfo>대표번호 : 02-2135-6318</S.FooterInfo>
								{!isMobile && <LineIcon width="2" height="12" iconColor="#ADB5BD" />}
								<S.FooterInfo>이메일 : ys.chang@tychepartners.co.kr</S.FooterInfo>
							</S.FooterContact>
						</S.ContentBox>
						<S.CopyRight>©TYCHEPARTNERS Corp. All Rights Reserved.</S.CopyRight>
					</S.FooterAbout>
				</S.FooterContent>
			</S.FooterWrapper>
		</S.FooterContainer>
	);
};

export default Footer;
